import React from "react";
import { Check, Circle, ArrowRight } from "lucide-react";

export function profileGaps(profile) {
  if (!profile) return [];
  return [
    { key: "logo", label: "Logo", done: !!profile.logo_url },
    { key: "location", label: "Location", done: !!(profile.city || profile.country_code) },
    { key: "description", label: "Description", done: !!profile.has_description },
    { key: "website", label: "Website", done: !!profile.website },
  ];
}

// Persistent until all four profile fields are filled; disappears automatically once complete.
export default function ProfileCompletenessNudge({ profile, onEditProfile }) {
  const steps = profileGaps(profile);
  if (!steps.length || steps.every((s) => s.done)) return null;
  const done = steps.filter((s) => s.done).length;
  return (
    <div className="mb-4 bg-white border-l-4 border-[#264839] border border-[#E8ECE9] px-5 py-3 flex flex-col sm:flex-row sm:items-center gap-3" data-testid="profile-completeness-nudge">
      <div className="flex-1 min-w-0">
        <div className="tracking-overline text-[10px] text-[#264839]">Complete your profile</div>
        <div className="text-sm text-[#11211A] mt-0.5"><strong>{done} of {steps.length}</strong> profile details filled in — buyers trust complete profiles.</div>
        <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1.5">
          {steps.map((s) => (
            <span key={s.key} className={`inline-flex items-center gap-1 text-xs ${s.done ? "text-[#7D8C85] line-through" : "text-[#11211A]"}`} data-testid={`profile-nudge-${s.key}`} data-done={s.done ? "true" : "false"}>
              {s.done ? <Check className="w-3 h-3 text-[#264839]" /> : <Circle className="w-3 h-3 text-[#C4CFC9]" />}{s.label}
            </span>
          ))}
        </div>
      </div>
      <button type="button" onClick={onEditProfile} className="btn-primary text-xs shrink-0" data-testid="profile-nudge-edit-btn">
        Complete profile <ArrowRight className="w-3 h-3" />
      </button>
    </div>
  );
}
